import { $patchStyleText } from '@lexical/selection';
import { Button } from '@nexelem/components';
import { $getSelection, $isRangeSelection, LexicalEditor } from 'lexical';
import * as React from 'react';
import { JSX, useCallback } from 'react';
import { ActionButton } from '../ActionButton';
import { ButtonWithMenu } from '../ButtonWithMenu';

export type LabelData = {
  label: string;
};

type FontFamilyOption = Record<
  'Arial' | 'Courier New' | 'Georgia' | 'Times New Roman' | 'Trebuchet MS' | 'Verdana',
  LabelData
>;

type FontSizeOption = Record<'10' | '11' | '12' | '13' | '14' | '15' | '16' | '17' | '18' | '19' | '20', LabelData>;

export const FONT_FAMILY_OPTIONS = [
  'Arial',
  'Courier New',
  'Georgia',
  'Times New Roman',
  'Trebuchet MS',
  'Verdana',
].reduce((acc, label) => {
  return { ...acc, [label]: { label } };
}, {} as FontFamilyOption);

export const FONT_SIZE_OPTIONS = ['10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20'].reduce(
  (acc, label) => {
    return { ...acc, [label]: { label } };
  },
  {} as FontSizeOption,
);

type FontDropDownProps = {
  editor: LexicalEditor;
  value: LabelData;
  type: 'font-family' | 'font-size';
  disabled?: boolean;
};

export function FontDropDown({ editor, value, type, disabled = false }: FontDropDownProps): JSX.Element {
  const handleClick = useCallback(
    (option: string) => () => {
      editor.update(() => {
        const selection = $getSelection();
        if ($isRangeSelection(selection)) {
          const patch = {
            [type]: `${option}px`,
          };
          $patchStyleText(selection, patch);
        }
      });
    },
    [editor, type],
  );

  return (
    <ButtonWithMenu
      disabled={disabled}
      content={() => (
        <>
          {Object.values(type === 'font-family' ? FONT_FAMILY_OPTIONS : FONT_SIZE_OPTIONS).map(({ label }) => (
            <ActionButton key={label} label={label} onClick={handleClick(label)} />
          ))}
        </>
      )}
      openingElement={
        <Button disabled={disabled} variant="text">
          {value.label}
        </Button>
      }
    />
  );
}
